import flowMenuIcon from 'Assets/images/module-switcher-icons/Icon_Flow builder.svg?url'
import answersMenuIcon from 'Assets/images/module-switcher-icons/Icon_Answers.svg?url'
import guidesMenuIcon from 'Assets/images/module-switcher-icons/Icon_Guides.svg?url'
import usersMenuIcon from 'Assets/images/module-switcher-icons/Icon_Users.svg?url'

const routes = {
  dashboard: {
    label: 'Flow Builder',
    path: '/dashboard',
    icon: flowMenuIcon
  },
  flows: {
    label: 'Flow Builder',
    path: '/flows',
    icon: flowMenuIcon
  },
  users: {
    label: 'Users',
    path: '/users',
    icon: usersMenuIcon
  },
  guides: {
    label: 'Guides',
    path: '/guides',
    icon: guidesMenuIcon
  },
  answers: {
    label: 'Answers',
    path: '/answers',
    icon: answersMenuIcon
  },
  'knowledge-base': {
    label: 'Knowledge Base',
    path: '/knowledge-base',
    icon: answersMenuIcon
  },
  'knowledge-base-import': {
    label: 'Knowledge Base',
    path: '/knowledge-base-import',
    icon: answersMenuIcon
  },
  training: {
    label: 'Training',
    path: '/training',
    icon: answersMenuIcon
  }
}

export default routes
